module.exports = __webpack_public_path__ + "materialdesignicons-webfont.ttf?1618c77b6c5c11926819a8868a083031";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.ttf?v=4.7.95
// module id = 1217
// module chunks = 0